const errorUiTexts = {
	unknownError: 'Fejl: Ukendt fejl.',
	emptyFields: 'Du skal udfylde alle felter.',
	userNotFound: 'Brugeren findes ikke i systemet.',
	invalidPassword: 'Ugyldigt password.',
};

const loginUiTexts = {
	login: 'Log ind',
	logout: 'Log ud',
	email: 'E-mail',
	password: 'Password',
	resetPassword: 'Nulstil password',
	passwordIsReset: 'Du har fået tilsendt en e-mail med et link til at nulstille dit password.',
	backToLogin: 'Tilbage til login',
	reset: 'Nulstil',
};

const adminUiTexts = {
	admin: 'Admin',
};

const gameUiTexts = {
	start: 'Start',
	resetBtn: 'Nulstil',
	backBtn: 'Tilbage',
	welcomeTo: 'Velkommen til',
	difficulties: {
		hard: 'Svær',
		medium: 'Middel',
		easy: 'Let'
	},
	timesOut: 'tiden er gået',
	task: 'Opgave',
	hint: 'Hint',
	choose: 'Vælg',
	ok: 'OK',
	points: 'Point',
	handOver: 'Aflever',
	correctAnswer: 'Korrekt svar',
	nextAssignment: 'Næste opgave',
	continueBtn: 'Videre',
	thankYouForPlaying: 'Tak fordi du spillede',
	qrCodeText: `<b>Scan QR-koden</b> og få en SMS med info om, hvornår du næste gang kan besøge os.`,
	playAgain: 'Spil igen'
};


export {
	errorUiTexts,
	loginUiTexts,
	adminUiTexts,
	gameUiTexts
};